const UserList = async (axiosPrivate) => {
    try {
        const res = await axiosPrivate.get('/dashboard/user-list/');
        if (res.status === 200) {
            return res;
        } else {
            throw new Error(`Unexpected status code: ${res.status}`);
        }
    } catch (err) {
        console.error("Error fetching user list:", err);
        throw err;
    }
};


const FilterAPI = async (axiosPrivate, filter) => {
    try {
        const res = await axiosPrivate.get(`/dashboard/search_claim/?search=${filter['search']}&start_date=${filter['start_date']}&end_date=${filter['end_date']}&operator=${filter['username']}`);
        if (res.status === 200) {
            return res;
        } else {
            throw new Error(`Unexpected status code: ${res.status}`);
        }
    } catch (err) {
        console.error("Error fetching user list:", err);
        throw err;
    }
};

const ClaimAPI = async (axiosPrivate, count=0) => {
    try {
        const res = await axiosPrivate.get(`/dashboard/claim/${count}`);
        if (res.status === 200) {
            return res;
        } else {
            throw new Error(`Unexpected status code: ${res.status}`);
        }
    } catch (err) {
        console.error("Error fetching user list:", err);
        throw err;
    }
};


const PartyAPI = async (axiosPrivate, value) => {
    try {
        const res = await axiosPrivate.get(`/data_entry/partymaster_searchbar/?party_master=${value}`);
        if (res.status === 200) {
            return res;
        } else {
            throw new Error(`Unexpected status code: ${res.status}`);
        }
    } catch (err) {
        console.error("Error fetching user list:", err);
        throw err;
    }
};

const ClaimPagination = async (axiosPrivate, url) => {
    try {
        const res = await axiosPrivate.get(url);
        if (res.status === 200) {
            return res;
        } else {
            throw new Error(`Unexpected status code: ${res.status}`);
        }
    } catch (err) {
        console.error("Error fetching user list:", err);
        throw err;
    }
};

const ClaimDownload = async (axiosPrivate, payload) => {
    try {
        const res = await axiosPrivate.post(`/report/claim-download/`, payload,{
            responseType: "blob",
        });
        if (res.status === 200) {
            return res;
        } else {
            throw res;
        }
    } catch (err) {
        console.error("Error fetching user list:", err);
        throw err;
    }
};

const ClaimUpdate = async (axiosPrivate, payload, claim_id) => {
    try {
        const res = await axiosPrivate.patch(`/dashboard/claim/${claim_id}/`, payload);
        if (res.status === 200) {
            return res;
        } else {
            throw res;
        }
    } catch (err) {
        console.error("Error fetching user list:", err);
        throw err;
    }
};


export { UserList, FilterAPI, ClaimAPI, PartyAPI, ClaimPagination, ClaimDownload, ClaimUpdate };